import React from 'react';

const PasswordChange = (props) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="var(--blue)" />
      <path
        d="M17.5 26.5H38.5C40.1557 26.5 41.5 27.8443 41.5 29.5V40C41.5 41.6557 40.1557 43 38.5 43H17.5C15.8443 43 14.5 41.6557 14.5 40V29.5C14.5 27.8443 15.8443 26.5 17.5 26.5"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 26.5V20.5C20.5 16.3606 23.8606 13 28 13C32.1394 13 35.5 16.3606 35.5 20.5V26.5"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PasswordChange;
